// FedCM ("Sign in with ..." prompts: navigator.credentials.get({ identity })) is carried out by
// the browser itself, outside the page and outside the service worker: Chrome fetches the
// identity provider's config, accounts list and token endpoints directly, with the visitor's
// own address and cookies. Through the proxy that showed the provider the visitor's real
// address (WELT asked GMX and WEB.DE for accounts on every page). The request could not work
// here anyway, since Chrome checks it against the proxy's origin, so it is refused the way
// Chrome refuses it where the API is turned off. Other credentials (passwords, passkeys) are
// left alone; they make no requests of their own.

import { ScramjetClient } from "@client/index";

export default function (client: ScramjetClient, self: any) {
	const { Promise, DOMException } = self;
	const refused = () =>
		Promise.reject(
			new DOMException(
				"The identity-credentials-get feature is not enabled in this document.",
				"NotAllowedError"
			)
		);

	if (self.CredentialsContainer) {
		client.Proxy("CredentialsContainer.prototype.get", {
			apply(ctx) {
				const options = ctx.args[0];
				if (options && typeof options === "object" && "identity" in options)
					ctx.return(refused());
			},
		});
	}
	// The other FedCM calls that reach the provider directly.
	if (self.IdentityCredential && self.IdentityCredential.disconnect) {
		client.Proxy("IdentityCredential.disconnect", {
			apply(ctx) {
				ctx.return(refused());
			},
		});
	}
	if (self.IdentityProvider && self.IdentityProvider.getUserInfo) {
		client.Proxy("IdentityProvider.getUserInfo", {
			apply(ctx) {
				ctx.return(refused());
			},
		});
	}
}
